import { api } from "@/lib/api";
import type { MixDetail, MixList } from "@/types/types";

export const mixService = {
  list: () => api<MixList>("/api/mixes"),
  get: (id: string) => api<MixDetail>(`/api/mixes/${encodeURIComponent(id)}`),
  refresh: () => api<{ building: boolean }>("/api/mixes/refresh", { method: "POST" }),
  save: (id: string) =>
    api<{ id: string; name: string; total: number }>(`/api/mixes/${encodeURIComponent(id)}/save`, { method: "POST" }),
};
